
  import createMeisterIcons from '../src/createMeisterIcons';

  const SearchAdd = createMeisterIcons("search-add", [["path",{"fill":"currentColor","d":"M4.3 11.55a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0m7.25-8.75a8.75 8.75 0 1 0 5.634 15.445l2.736 2.735a.75.75 0 0 0 1.06-1.06l-2.735-2.736A8.75 8.75 0 0 0 11.55 2.8M7.8 11.55a.75.75 0 0 1 .75-.75h2.25V8.55a.75.75 0 0 1 1.5 0v2.25h2.25a.75.75 0 1 1 0 1.5H12.3v2.25a.75.75 0 1 1-1.5 0V12.3H8.55a.75.75 0 0 1-.75-.75","key":"849686829d9fc6dc2384bb9019ce3fa727353370","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default SearchAdd
  